import type { FallbackProps } from 'react-error-boundary';

type SentryFallbackProps = {
  error: unknown;
  componentStack?: string;
  eventId?: string;
  resetError: () => void;
};

export function SentryErrorFallbackAdapter(props: SentryFallbackProps) {
  const error = props.error instanceof Error ? props.error : new Error(String(props.error));
  return <ErrorFallback error={error} resetErrorBoundary={props.resetError} />;
}

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <div className="min-h-[50vh] flex items-center justify-center p-8">
      <div className="bg-white rounded-xl shadow-md p-8 max-w-md text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h1 className="text-lg font-bold text-td-navy mb-2">Er ging iets mis</h1>
        <p className="text-sm text-td-muted mb-4">
          {import.meta.env.DEV ? message : 'Er is een onverwachte fout opgetreden.'}
        </p>
        <button
          onClick={resetErrorBoundary}
          className="px-4 py-2 bg-td-blue text-white rounded-lg text-sm font-medium hover:bg-td-blue/90 transition-colors"
        >
          Opnieuw proberen
        </button>
      </div>
    </div>
  );
}
